import { useTranslation } from 'react-i18next';

import {
  ACTIVE_LANGUAGES,
  DEFAULT_LANGUAGE,
  type SupportedLanguageCode,
} from '@/i18n/languages';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (language: SupportedLanguageCode) => {
    const isValidLanguage = ACTIVE_LANGUAGES.some(
      (lang) => lang.code === language
    );
    if (isValidLanguage) {
      i18n.changeLanguage(language);
    } else {
      console.warn(`Language ${language} is not active`);
      i18n.changeLanguage(DEFAULT_LANGUAGE);
    }
  };

  const getCurrentLanguage = (): SupportedLanguageCode => {
    const currentLang = i18n.language as SupportedLanguageCode;
    const isValidLanguage = ACTIVE_LANGUAGES.some(
      (lang) => lang.code === currentLang
    );
    return isValidLanguage ? currentLang : DEFAULT_LANGUAGE;
  };

  const isTurkish = () => {
    return i18n.language === 'tr';
  };

  const isEnglish = () => {
    return i18n.language === 'en';
  };

  // Gelecekte eklenecek diller için yardımcı fonksiyonlar:
  // const isGerman = () => {
  //   return i18n.language === 'de';
  // };
  //
  // const isSpanish = () => {
  //   return i18n.language === 'es';
  // };

  return {
    currentLanguage: getCurrentLanguage(),
    changeLanguage,
    isTurkish,
    isEnglish,
    // isGerman,
    // isSpanish,
  };
};
